module.exports = __webpack_public_path__ + "static/media/android.9929eb88.png";